export default "__VITE_ASSET__6G63p4GW__"